import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authenticateUser } from 'redux/auth/authActions';
import { getCookie, deleteCookie } from 'utils/storage';

const useAuthenticateFromCookies = () => {
    const [cookiesCkecked, setCookiesCkecked] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const pId: number = parseInt(getCookie('portfolio_id'), 10);

    useEffect(() => {
        const memberToken: string = decodeURI(getCookie('sinvest_jwt_token'));

        const contactId: number = parseInt(getCookie('client_id'), 10);

        if (memberToken && contactId) {
            const redirectUrl = pId ? `/investments/${pId}` : '/';

            const user = {
                contactId,
                jwtAccessToken: memberToken.split(' ')[1],
            };

            dispatch(authenticateUser(user));
            navigate(redirectUrl);
        } else {
            deleteCookie('sinvest_jwt_token');
            deleteCookie('client_id');
            deleteCookie('portfolio_id');
        }
        setCookiesCkecked(true);
    }, []);

    return { cookiesCkecked };
};

export default useAuthenticateFromCookies;
